import React, {useContext} from 'react'
import {Form, Input} from "antd";
import {RecipeUpdateContext} from "../../../../../context/RecipeUpdateContext";

const HeaderCode = () => {
    const {byId} = useContext(RecipeUpdateContext)
    const [recipeById, setRecipeById] = byId


    const handleCodeChange = ({target}) => {
        let mockResponse = Object.assign({}, recipeById)
        mockResponse.recipe.code = target.value
        setRecipeById(mockResponse)
    }

    return(
        <React.Fragment>
            <Form.Item
                className={'font-bold'}
                label={'Reçete Kodu'}
                name={'recipeCode'}
                onChange={handleCodeChange}
                initialValue={recipeById.recipe.code}
            >
                <Input />
            </Form.Item>
        </React.Fragment>
    )
}
export default HeaderCode